import { Flex } from 'antd';
import styles from '../navbar.module.scss';
import { FilledCareIcon, ResultsIcon, TrustPilotIcon } from '../../../common/all-icons/custom-icons';

const TrustSection = () => {
  const trusts = [
    {
      icon: <TrustPilotIcon />,
      title: '4.8 average rating',
      desc: 'Real support when you need it',
    },
    { icon: <FilledCareIcon />, title: 'Fast medication delivery', desc: 'Treatments arrive in 3-5 days' },
    { icon: <ResultsIcon />, title: 'Real results', desc: '89% of users see meaningful progress in 30 days' },
  ];

  return (
    <div className={styles.signupSection} style={{ backgroundColor: '#F8F8F8' }}>
      <div className={styles.trustSection}>
        <div className={`${styles.benefitsHeading} w-100`}>Why 30,000 people chose Elevate Health</div>
        <div className={styles.trustWrap}>
          {trusts.map((trust) => {
            return (
              <Flex className={styles.trustBox} vertical justify="center" align="center">
                <div className={styles.boxSection}>
                  {trust?.icon}
                  <Flex vertical justify="center" align="center" gap={8}>
                    <div className={`${styles.boxTitle} text-align-center`}>{trust?.title}</div>
                    <div style={{ color: 'var(--user-main-text)' }} className={`${styles.boxDesc} text-align-center`}>
                      {trust?.desc}
                    </div>
                  </Flex>
                </div>
              </Flex>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TrustSection;
